import React from 'react';
import { useTranslation } from 'react-i18next';
import type { ProgressStatus } from '../types';

const STATUS_CLASSES: Record<ProgressStatus, { chip: string; dot: string }> = {
  excellent: { chip: 'bg-school-success-soft text-school-success', dot: 'bg-school-success' },
  good: { chip: 'bg-school-info-soft text-school-info', dot: 'bg-school-info' },
  in_progress: { chip: 'bg-school-warning-soft text-school-warning', dot: 'bg-school-warning' },
  not_started: { chip: 'bg-school-neutral-soft text-school-neutral', dot: 'bg-school-neutral' },
};

interface StatusChipProps {
  status: ProgressStatus;
  /** Optional trailing text, e.g. the score. */
  suffix?: string;
}

const StatusChip: React.FC<StatusChipProps> = ({ status, suffix }) => {
  const { t } = useTranslation();
  const classes = STATUS_CLASSES[status];
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-lg px-2.5 py-1 text-xs font-semibold ${classes.chip}`}
    >
      <span className={`h-2 w-2 rounded-full ${classes.dot}`} />
      {t(`school_status_${status}`)}
      {suffix && <span className="font-normal opacity-80">· {suffix}</span>}
    </span>
  );
};

export default StatusChip;
